var _a;
import Vue from 'vue';
import { Const } from '../const.mod';
/**
 * mutations extension for store module
 */
export var mutations = (_a = {},
    /**
     * pass config to providers,
     * start providers and register with state
     * @param data { providers:<Array<IProvider>, response:any}
     */
    _a[Const.SET_REGISTER_PROVIDERS] = function (state, data) {
        var token = data.response.data.token;
        data.providers.map(function (p) {
            try {
                // retrieve classname from object member
                var className = p.constructorName;
                // retrieve provider configuration with cache, seeders, patchers, etc.
                var config = data.response.data[className];
                var cacheItemTag = config.cacheItemTag;
                if (cacheItemTag !== 'undefined') {
                    // inject token
                    config['token'] = token;
                    // add hearbeat property fpr this provider
                    Vue.set(state.heartbeats, cacheItemTag, 1);
                    // add to state providers
                    Vue.set(state.providers, cacheItemTag, p);
                    // start the provider
                    p.start(config);
                }
            }
            catch (ex) {
                // console.log('SET_REGISTER_PROVIDERS [ex]', ex)
            }
        });
    },
    /**
     * update heartbeat for single provider
     */
    _a[Const.SET_HEARTBEAT] = function (state, params) {
        var cacheTag = params.cacheItemTag;
        try {
            state.heartbeats[cacheTag]++;
        }
        catch (ex) {
            // console.log('SET_HEARTBEAT [ex]', ex)
            state.heartbeats[cacheTag] = 0;
        }
    },
    _a);



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/store/mutations.ts
// module id = null
// module chunks = 